import { MatDialog } from '@angular/material/dialog';
import { EventEmitter, Injectable } from '@angular/core';
import { TypeDialog, ButtonsDialog } from './model-type';
import { MyModalComponent } from './shared/my-modal.component';
@Injectable()
export class OpenModal {

    constructor(public dialog: MatDialog) {  }

    openDialog(eType: TypeDialog, sTitle: string, sMessage: string, eButtons: ButtonsDialog,
               nWidth: number = 300, nHeigh: number = 300) {
        let dialogRef: any;
        // let respuesta: number;
        dialogRef = this.dialog.open(MyModalComponent, {
              minWidth: nWidth + 'px',
              width: nWidth + 'px',
              data: { title: sTitle, message: sMessage, buttons: eButtons, type: eType  }
        });

        return dialogRef;
    }
}
